/**
 * Mobotix T26 IP-SIP door station catalog.
 *
 * Verified against the official Mobotix T26B datasheet PDF
 * (Mx_TS_T26B_V1.09_EN.pdf, hosted on mobotix.com) on 2026-05-15.
 *
 * Schema note: source `accessControl` is a string in the JSON; the
 * IntercomSpec schema expects an array — mapped accordingly.
 * `ikRating` (IK10) dropped — not in schema.
 *
 * Mobotix does not manufacture a dedicated indoor video intercom
 * monitor — T26 pairs with the MOBOTIX HUB app, MxMC desktop client,
 * or third-party SIP phones. Skipped: T25 / T24 (discontinued).
 */

import type { EquipmentCatalogEntry } from './equipmentCatalogEntry';

export const MOBOTIX_INTERCOM_CATALOG: EquipmentCatalogEntry[] = [
  {
    id: 'mobotix-t26b-white',
    manufacturer: 'Mobotix',
    model: 'T26B CamCore (White)',
    category: 'intercom',
    tagline: '6 MP hemispheric IP-SIP door station, 180°×180° fisheye B016 lens, IP65/IK10',
    verified: true,
    datasheetUrl: 'https://www.mobotix.com/sites/default/files/2023-08/Mx_TS_T26B_V1.09_EN.pdf',
    specs: {
      type: 'ip-sip',
      side: 'outdoor-station',
      cameraMP: 6,
      callButtons: 1,
      ipRating: 'IP65',
      poe: true,
    },
  },

  {
    id: 'mobotix-t26b-black',
    manufacturer: 'Mobotix',
    model: 'T26B CamCore (Black)',
    category: 'intercom',
    tagline: '6 MP hemispheric IP-SIP door station, black bezel, IP65/IK10',
    verified: true,
    datasheetUrl: 'https://www.mobotix.com/sites/default/files/2023-08/Mx_TS_T26B_V1.09_EN.pdf',
    specs: {
      type: 'ip-sip',
      side: 'outdoor-station',
      cameraMP: 6,
      callButtons: 1,
      ipRating: 'IP65',
      poe: true,
    },
  },

  {
    id: 'mobotix-t26b-darkgray',
    manufacturer: 'Mobotix',
    model: 'T26B CamCore (Dark Gray)',
    category: 'intercom',
    tagline: '6 MP hemispheric IP-SIP door station, dark gray bezel, IP65/IK10',
    verified: true,
    datasheetUrl: 'https://www.mobotix.com/sites/default/files/2023-08/Mx_TS_T26B_V1.09_EN.pdf',
    specs: {
      type: 'ip-sip',
      side: 'outdoor-station',
      cameraMP: 6,
      callButtons: 1,
      ipRating: 'IP65',
      poe: true,
    },
  },

  {
    id: 'mobotix-t26b-silver',
    manufacturer: 'Mobotix',
    model: 'T26B CamCore (Silver)',
    category: 'intercom',
    tagline: '6 MP hemispheric IP-SIP door station, silver bezel, IP65/IK10',
    verified: true,
    datasheetUrl: 'https://www.mobotix.com/sites/default/files/2023-08/Mx_TS_T26B_V1.09_EN.pdf',
    specs: {
      type: 'ip-sip',
      side: 'outdoor-station',
      cameraMP: 6,
      callButtons: 1,
      ipRating: 'IP65',
      poe: true,
    },
  },

  {
    id: 'mobotix-t26-keypadrfid',
    manufacturer: 'Mobotix',
    model: 'T26 with KeypadRFID Module',
    category: 'intercom',
    tagline: '6 MP T26 door station with KeypadRFID module — keyless entry via PIN or RFID transponder',
    verified: true,
    datasheetUrl: 'https://www.mobotix.com/sites/default/files/2023-08/Mx_TS_T26B_V1.09_EN.pdf',
    specs: {
      type: 'ip-sip',
      side: 'outdoor-station',
      cameraMP: 6,
      callButtons: 1,
      ipRating: 'IP65',
      poe: true,
      accessControl: ['keypad', 'mifare'],
    },
  },

  {
    id: 'mobotix-t26-mifare',
    manufacturer: 'Mobotix',
    model: 'T26 with MIFARE Module',
    category: 'intercom',
    tagline: '6 MP T26 door station with RFID/MIFARE access control module, IP65/IK10',
    verified: true,
    datasheetUrl: 'https://www.mobotix.com/sites/default/files/2023-08/Mx_TS_T26B_V1.09_EN.pdf',
    specs: {
      type: 'ip-sip',
      side: 'outdoor-station',
      cameraMP: 6,
      callButtons: 1,
      ipRating: 'IP65',
      poe: true,
      accessControl: ['mifare'],
    },
  },
];
